import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { PostalAddress } from 'src/app/shared-lib/global/models';

@Component({
  selector: 'app-default-address-warning',
  templateUrl: './default-address-warning.component.html',
  styleUrls: ['./default-address-warning.component.scss', '../../account/card-style.scss'],
  standalone: false
})
export class DefaultAddressWarningComponent implements OnInit {

  @Input() address: PostalAddress;
  @Input() type: 'shipping' | 'billing';

  constructor(
    private modalController: ModalController
  ) { }

  ngOnInit() { }

  close() {
    this.modalController.dismiss({ accept: false });
  }

  accept() {
    this.modalController.dismiss({ accept: true });
  }

}
